import { getZod } from '../lib/zodLoader';
import type { z } from 'zod';

// Lazy-loaded schema factory
let cachedSchema: z.ZodObject<any> | null = null;

export async function getVehicleRequestSchema() {
  if (cachedSchema) return cachedSchema;

  const z = await getZod();
  
  cachedSchema = z.object({
    name: z.string().min(2, 'Name must be at least 2 characters'),
    email: z.string().email('Please enter a valid email address'),
    phone: z.string().optional().refine(
      (val) => !val || val.length >= 10,
      'Phone number must be at least 10 digits if provided'
    ),
    make: z.string().min(1, 'Please specify a make'),
    model: z.string().min(1, 'Please specify a model'),
    year_min: z.string().optional(),
    year_max: z.string().optional(),
    body_type: z.string().optional(),
    budget_min: z.string().optional(),
    budget_max: z.string().optional(),
    max_mileage: z.string().optional(),
    details: z.string().max(500, 'Details must be 500 characters or less').optional(),
    preferred_color: z.string().optional(),
  });

  return cachedSchema;
}

export type VehicleRequestData = {
  name: string;
  email: string;
  phone?: string;
  make: string;
  model: string;
  year_min?: string;
  year_max?: string;
  body_type?: string;
  budget_min?: string;
  budget_max?: string;
  max_mileage?: string;
  details?: string;
  preferred_color?: string;
};